import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
@Component
export default class HomeListItem extends Vue {
    public title: string = 'HomeListItem';

    public configs = new CommonConfig();
    @Prop({ default: null })
    public data: any;

    @Prop({ default: false })
    public selected!: boolean;
}
